/**
 * Test IDs for QA automation.
 */
export const testIds = {
  reportActionsSavedReports: "report-actions-saved-reports",
  reportActionsClear: "report-actions-clear",
  reportActionsNoSavedReports: "report-actions-no-saved-reports",
  reportActionsSavedReportOption: "report-actions-saved-report-option",
  reportActionsDeleteSavedReport: "report-actions-delete-saved-report",
  reportActionsOpenSaveDialog: "report-actions-open-save-dialog",
  reportActionsSavedReportName: "report-actions-saved-report-name",
  reportActionsCancel: "report-actions-cancel",
  reportActionsSave: "report-actions-save",
} as const;
